type Listener = () => void;

// Maps a unique PlayRangeComponent instance ID → whether its tiles are too small.
// The global value is true when any mounted instance reports hidden=true.
const instanceMap = new Map<string, boolean>();
const listeners = new Set<Listener>();

function notify() {
  listeners.forEach(l => l());
}

export function registerSpeakerLabelHidden(instanceId: string, hidden: boolean) {
  if (hidden) {
    instanceMap.set(instanceId, true);
  } else {
    instanceMap.delete(instanceId);
  }
  notify();
}

export const speakerLabelAutoHiddenStore = {
  subscribe(listener: Listener) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  getSnapshot(): boolean {
    return instanceMap.size > 0;
  }
};
